import CartModel from '../models/cart.model';
const CART_KEY = "shopping_cart";

export const getCart = () => {
    var local_store = JSON.parse(window.localStorage.getItem(CART_KEY));
    var cart_model = new CartModel(local_store);       
    return cart_model;
};

export const saveCart = cart => {
    window.localStorage.setItem(CART_KEY, JSON.stringify(cart));
};

export const destroyCart = () => {
    window.localStorage.removeItem(CART_KEY);
};

export default {
    getCart,
    saveCart,
    destroyCart
};